import { Species } from '../../api/fishrules/getSpeciesAtLocation';

interface RestrictionsAndRequirements {
  id: number;
  label: string;
  name: string;
  description: string;
  type: string;
}

const getRestrictionsAndRequirements = (species: Species): RestrictionsAndRequirements[] => [
  ...species.prohibitions,
  ...species.restrictions,
  ...species.requirements,
];

const hasRestrictions = (species: Species): boolean =>
  getRestrictionsAndRequirements(species).length > 0;

export { getRestrictionsAndRequirements, hasRestrictions };
